<div
	class="au-linked-object-btn"
	[class.not-clickable]="!clickable"
	(click)="onClick($event)"
>
	<span class="text">
		{{ text }}
	</span>
</div>
